<div class="boxWhite">

  <div class="headInfo">
    <div class="infoVcb">

      <div class="boxViaje" (click)="navigateToViaje()" style="cursor: pointer;">
        <div class="ico">
          <img src="assets/img/icoInfo.svg" alt="">
        </div>
        <div class="servicio">
          <span>SERVICIO</span>
          <h4>{{ viajeSeleccionado.servicio }}</h4>
        </div>
        <div class="item">
          <span>DESTINO</span>
          <p>{{ viajeSeleccionado.sucursalDestino?.nombre}}</p>
        </div>
        <div class="item">
          <span>INICIO</span>
          <p>{{ viajeSeleccionado.fechahoraInicio | date:'HH:mm' }}</p>
        </div>
        <div class="item">
          <span>DURACIÓN</span>
          <p>--</p>
        </div>
        <div class="item">
          <span>TIPO BUS R.</span>
          <p>{{ viajeSeleccionado.tipoMovilRequerido || '--'}}</p>
        </div>
        <div class="item">
          <span>ESTADO</span>
          <p>{{ viajeSeleccionado.estado }}</p>
        </div>
      </div>

      <div class="cbActual">
        <div class="item">
          <span>ID BUS ACTUAL</span>
          <p>{{ viajeSeleccionado.movil?.numeroInterno || 'No asignado' }}</p>
        </div>
        <div class="item">
          <span>PATENTE ACTUAL</span>
          <p>{{ viajeSeleccionado.movil?.patente || 'No asignado' }}</p>
        </div>
        <div class="item">
          <span>TIPO BUS ACTUAL</span>
          <p>{{ viajeSeleccionado.movil?.tipoMovil?.codigo || 'No asignado' }}</p>
        </div>
        <div class="item mt-2">
          <button class="btn btnOrange" (click)="toggleReemplazo()" *ngIf="!showReemplazo && selectedBus">
            Mostrar reemplazo
          </button>
        </div>
      </div>
    </div>

    <div class="reemplazo" *ngIf="showReemplazo && selectedBus">
      <button class="btn btnClose" (click)="closeReemplazo()">
        <img src="assets/img/icoClose.svg" alt="">
      </button>
      <div class="groupItems">
        <div class="item">
          <span>PATENTE</span>
          <p>{{ selectedBus.patente }}</p>
        </div>
        <div class="item">
          <span>TIPO</span>
          <p>{{ selectedBus.tipoMovil?.codigo }}</p>
        </div>
        <div class="item">
          <span>ESTADO</span>
          <p class="clBlue">{{ selectedBus.estado }}</p>
        </div>
      </div>
      <button *ngIf="!asignandoMovil && tienePermisoAsignarMovil()" class="btn btnOrange w-100"
      [disabled]="isViajeEnCurso"
      (click)="asignarMovil()">
        ASIGNAR
      </button>

      <button *ngIf="asignandoMovil && tienePermisoAsignarMovil()" class="btn btnOrange w-100" >
        ASIGNANDO...
      </button>
    </div>
  </div>


  <div class="headBox">
    <div class="filtros">
      <div class="buscar itemForm">
        <input type="search" class="form-control" placeholder="Buscar..." [ngModel]="searchText"
          (ngModelChange)="onSearchChange($event)">
      </div>
    </div>
  </div>

  <!-- Initial loading indicator only shown when no data is available yet -->
  <div *ngIf="loading && filteredBuses.length === 0" class="text-center p-3">
    <p>Cargando buses...</p>
  </div>

  <div *ngIf="error" class="alert alert-danger m-3">
    {{ error }}
  </div>

  <!-- Table is always visible once data is loaded, regardless of loading state -->
  <div class="tableResp" *ngIf="filteredBuses.length > 0 || (!loading && !error)" infiniteScroll
    [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000" (scrolled)="onScroll()" [scrollWindow]="false"
    [infiniteScrollDisabled]="loading || desactivarInfiniteScroll">
    <table class="table">
      <thead>
        <tr>
          <th (click)="onSort('numeroInterno')" style="cursor: pointer;">
            ID
            <span *ngIf="orderBy === 'numeroInterno'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
          </th>
          <th (click)="onSort('patente')" style="cursor: pointer;">
            PATENTE
            <span *ngIf="orderBy === 'patente'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
          </th>
          <th (click)="onSort('estado')" style="cursor: pointer;">
            ESTADO
            <span *ngIf="orderBy === 'estado'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
          </th>
          <th (click)="onSort('estadoFechaTerminoPlanificado')" style="cursor: pointer;">
            HORA DE LLEGADA
            <span *ngIf="orderBy === 'estadoFechaTerminoPlanificado'"
              [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
          </th>
          <th (click)="onSort('codigo')" style="cursor: pointer;">
            T. BUS
            <span *ngIf="orderBy === 'codigo'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
          </th>
          <th>
            CARGA/COMBUSTIBLE
            <span *ngIf="orderBy === 'codigo'" [innerHTML]="orderAsc ? '&#9650;' : '&#9660;'"></span>
          </th>
          <th>ACCIÓN</th>
        </tr>
      </thead>


      <tbody>
        <tr *ngIf="filteredBuses.length === 0">
          <td colspan="6" class="text-center">
            {{ searchText ? 'No se encontraron buses que coincidan con la búsqueda' : responseMsg }}
          </td>
        </tr>

        <tr *ngFor="let bus of filteredBuses; let i = index" [class.selected]="i === selectedIndex"
          (click)="selectBus(bus, i)" 
          [style.cursor]="isViajeEnCurso || bus.estado !== 'DISPONIBLE' ? 'not-allowed' : 'pointer'"
          [class.disabled-row]="isViajeEnCurso || bus.estado !== 'DISPONIBLE'">
          <td>{{ bus.numeroInterno }}</td>
          <td>{{ bus.patente }}</td>
          <td><span class="clBlue">{{ bus.estado }}</span></td>
          <td>{{ bus.estadoFechaTerminoPlanificado ? (bus.estadoFechaTerminoPlanificado | date:'HH:mm') : '--' }}</td>
          <td>{{ bus.tipoMovil?.codigo }}</td>
          <td>{{getEnergiaDisponible(bus)}}</td> <!--COPNFIGURAR AQUI EL VALOR DE CARGA Y NO BORRAR EL %-->
          <td>
            <div class="btns">
              <button class="btn btnVer" (click)="viewBusDetails(bus, $event)"><img src="assets/img/icoVer.svg"
                  alt=""></button>
            </div>
          </td>
        </tr>
      </tbody>

    </table>
    <!-- Loading indicator for infinite scroll removed as requested -->
  </div>

</div>
